<template>
  <div class="login-form scrollbar">
    <div class="login-form__header">
      <img class="login-form__logo" src="../assets/img/edgefirst_hexagon.svg">
      <h1>Create new account.</h1>
    </div>
    <div class="login-form__body">
      <div v-if="showInvitationOnlyMessage" class="server-warning">
        This server accepts registration by invitation only. For production server register at
        <button
          type="button"
          class="server-warning__link"
          @click="openProductionServer"
        >
          https://edgefirst.studio/
        </button>
      </div>
      <form class="login-form__form" @submit.prevent="handleCreateAccount">
        <label class="required" for="form_create-email">Email</label>
        <input
          id="form_create-email"
          v-model="userCreateEmail"
          type="text"
          placeholder="Enter your email"
        >
        <label for="form_create-org">Organization</label>
        <input
          id="form_create-org"
          v-model="userCreateOrganization"
          type="text"
          placeholder="Enter your organization name"
        >

        <label class="required" for="form_create-username">Username</label>
        <input
          id="form_create-username"
          v-model="userCreateUsername"
          type="text"
          placeholder="Enter your preferred username"
        >

        <label class="required" for="form_create-password">Password</label>
        <input
          id="form_create-password"
          v-model="userCreatePassword"
          type="password"
          maxlength="72"
        >
        <label class="required" for="form_create-confirm_password">Confirm Password</label>
        <input
          id="form_create-confirm_password"
          v-model="userConfirmPassword"
          type="password"
          maxlength="72"
        >
        <div class="submit-container">
          <span v-if="error" class="_error">{{ error }}</span>
          <span v-if="successMessage" class="_success">{{ successMessage }}</span>
          <button type="submit" class="button">Create account</button>
        </div>
      </form>
    </div>
    <hr class="social-divider">
    <SocialLoginButtons />
    <h3 class="new-user">Already have an account? <button class="button-link" @click="handleGoToLogin">Sign in.</button></h3>
  </div>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { event } from 'vue-gtag';
import SocialLoginButtons from './SocialLoginButtons.vue';

export default {
  name: 'SignupForm',
  components: {
    SocialLoginButtons,
  },
  data() {
    return {
      dataConnect: null,
      userCreateFirstname: '',
      userCreateLastname: '',
      userCreateUsername: '',
      userCreateEmail: '',
      userCreateOrganization: '',
      userCreatePassword: '',
      userConfirmPassword: '',
      error: '',
      successMessage: '',
    };
  },
  computed: {
    isSaas() {
      return this.$store.state.appVersion.isSaas;
    },
    showInvitationOnlyMessage() {
      if (typeof window === 'undefined' || !window.location) {
        return false;
      }

      const hostname = window.location.hostname.toLowerCase();
      if (!hostname) {
        return false;
      }

      return hostname === 'localhost'
        || hostname === '127.0.0.1'
        || hostname.includes('local')
        || hostname.includes('test')
        || hostname.includes('dev')
        || hostname.includes('stage')
        || hostname.includes('ocean');
    },
    version() {
      return this.$store.state.appVersion.version;
    },
    frontendVersion() {
      return this.$store.state.appVersion.frontendVersion;
    },
  },
  created() {
    this.dataConnect = new DatastoreConnect();
  },
  methods: {
    handleGoToLogin() {
      this.$router.push({ path: '/login' });
    },
    openProductionServer() {
      window.open('https://edgefirst.studio/', '_blank', 'noopener,noreferrer');
    },
    handleError(error) {
      if (error.code === 101) {
        this.error = error.message;
      }
    },
    async handleRegister() {
      this.successMessage = '';
      this.error = '';

      if (!this.userCreateEmail) {
        this.error = "Missing email.";
        return;
      }

      const resp = await this.dataConnect.registerNewUser({
        email: this.userCreateEmail,
        company: this.userCreateOrganization,
      })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
      if (!resp || resp.error || !resp.result) {
        if (resp && resp.error) {
          console.error(resp.error);
          this.handleError(resp.error);
          return;
        }
      }

      this.successMessage = resp.result;
    },
    async handleCreateAccount() {
      event('register_submit', {
        category: 'registration',
        label: 'User submitted the registration form',
      });

      this.successMessage = '';
      this.error = '';

      if (!this.userCreateUsername) {
        this.error = "Missing username.";
        event('register_form_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing username.",
        });
        return;
      }

      if (!this.userCreateEmail) {
        this.error = "Missing email.";
        event('register_form_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing email.",
        });
        return;
      }

      if (!this.userCreatePassword) {
        this.error = "Missing password.";
        event('register_form_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing password.",
        });
        return;
      }

      if (!this.userConfirmPassword) {
        this.error = "Missing confirm password.";
        event('register_form_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Missing confirm password.",
        });
        return;
      }

      if (this.userCreatePassword !== this.userConfirmPassword) {
        this.error = "Confirm password does not match.";
        event('register_form_failure', {
          category: 'registration',
          label: 'User failed to register',
          reason: "Confirm password does not match.",
        });
        return;
      }
      const resp = await this.dataConnect.registerNewUser({
        username: this.userCreateUsername,
        email: this.userCreateEmail,
        password: this.userCreatePassword,
        company: this.userCreateOrganization,
      })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
      if (!resp || resp.error || !resp.result) {
        if (resp && resp.error) {
          console.error(resp.error);
          event('register_failure', {
            category: 'registration',
            label: 'User failed to register',
            reason: resp.error,
          });
          this.handleError(resp.error);
          return;
        }
      }

      event('register_success', {
        category: 'registration',
        label: 'User successfully registered',
      });
      this.successMessage = resp.result;
    },
  },

};
</script>

<style lang="scss" scoped>

.login-form {
  width: 610px;
  padding: 60px 80px 60px 80px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: fit-content;
  box-shadow: 0 0 35px rgb(0 0 0 / 50%), 0 0 10px rgb(0 0 0 / 50%);
  min-height: fit-content;
  margin: auto;
  @include themify() {
    background: themed('login-form');
    color: themed('body-text-color');
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
    margin-bottom: 10px;

    h1 {
      margin-top: 10px;
      text-align: center;
      font-size: 24px;
    }
  }

  &__logo {
    max-width: 100%;
    height: 160px;
    object-fit: contain;
  }

  &__body {
    display: flex;
    flex-direction: column;
    text-align: left;
    // margin-bottom: 16px;
    flex: 1 1 auto;
    @include themify() {
      color: themed('body-text-color');
    }
  }

  .server-warning {
    margin-bottom: 12px;
    padding: 10px 12px;
    border: 1px solid #cc1f1f;
    border-radius: 8px;
    background: #fff2f2;
    color: #b00000;
    font-size: 14px;
    line-height: 1.4;

    &__link {
      margin: 0;
      padding: 0;
      border: 0;
      background: transparent;
      cursor: pointer;
      font-size: inherit;
      line-height: inherit;
      font-family: inherit;
      color: #b00000;
      font-weight: 700;
      text-decoration: underline;
      text-align: left;
      word-break: break-word;
    }
  }

  .new-user {
    text-align: center;
    font-weight: normal;
    font-size: 16px;
    padding-top: 20px;
    margin-top: auto;
    margin-bottom: 0.5rem;
  }
}

.social-divider {
  margin: 20px 0 4px;
}

@media (max-width: $breakpoint-sm) {
  .login-form {
    padding: 32px;
  }
}
@media (max-width: $breakpoint-md) {
  .login-form {
    width: 100%;
  }
}

form {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  label {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 2px;

      &.required::after {
      content: '*';
      font-size: 14px;
      font-weight: 700;
      padding-left: 1px;
      @include themify() {
        color: themed('color-primary');
      }
    }
  }

  input {
    width: 100%;
    height: 42px;
    background: transparent;
    padding: 10px;
    border: 2px solid rgb(189, 186, 186);
    border-radius: 8px;
    color: black;
    font-size: 16px;
    outline: none;

    &:focus, &:focus-visible {
      @include themify() {
        border: 2px solid themed('color-primary');
        box-shadow:  0 0px 2px themed('color-primary-300');
      }
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
  }
  input:not(:last-of-type) {
    margin-bottom: 16px;
  }

  button[type=submit] {
    letter-spacing: 0.1em;
    width: 100%;
    height: 50px;
    border-radius: 6px;
  }

  .submit-container {
    margin-top: 16px;
    span._error {
      margin: 0 0 4px 0;
      font-weight: 400;
      font-size: 16px;
      text-align: left;
      margin-bottom: 0.5rem;
      @include themify() {
        color: themed('login-error');
      }
    }

    span._success {
      margin: 0 0 4px 0;
      font-weight: 400;
      font-size: 16px;
      text-align: left;
      margin-bottom: 0.5rem;
      @include themify() {
        color: themed('login-success');
      }
    }
  }
}
</style>
